import { Form, useForm } from "@/components/form";
import { Grid, Box, Snackbar, Alert, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import * as z from "zod";
import { useValidateLead } from "../api/validateLead";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useValidationLead } from "../api/getValidationGuid";
import { Loading } from "@/components/shared";
import { NotFound } from "@/components/misc";

const defaultValues = {
  agree: false,
};

export const LeadValidationForm = () => {
  const { t } = useTranslation();
  const { guid } = useParams();
  const validateLeadMutation = useValidateLead({ guid });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const {
    data: leadData,
    isLoading: leadDataIsLoading,
    isError: leadDataIsError,
  } = useValidationLead({ guid });

  const schema = z.object({
    agree: z.boolean().refine((val) => val === true, {
      message: t("lead.validateLead.agree"),
    }),
  });

  const methods = useForm({
    options: { defaultValues },
    schema,
  });

  const handleAgree = (agreeValue: boolean) => {
    if (guid) {
      validateLeadMutation.mutate(
        { guid, data: { agree: agreeValue } },
        {
          onSuccess: () => {
            setSnackbarMessage(t("lead.validateLead.validationSuccessfull"));
            setOpenSnackbar(true);
            setTimeout(() => {
              setTimeout(() => {
                window.location.href = "https://www.otpbanka.rs/";
              }, 2000);
            }, 2000);
          },
          onError: (error) => {
            setSnackbarMessage(`Error: ${error.message}`);
            setOpenSnackbar(true);
          },
        }
      );
    }
  };

  if (leadDataIsLoading || !guid) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Loading />
      </Box>
    );
  }

  if (leadDataIsError) {
    return <NotFound />;
  }

  return (
    <>
      <Form {...methods}>
        <Grid container alignItems="center" spacing={2} mt={1}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="body1">
                {`${t("lead.validateLead.agreeLabel")} ${
                  leadData?.partnerName
                }?`}
              </Typography>
              <Button
                variant="contained"
                color="success"
                disabled={validateLeadMutation.isLoading || !guid}
                onClick={() => handleAgree(true)}
              >
                {t("dialogs.yes")}
              </Button>

              <Button
                variant="contained"
                color="error"
                disabled={validateLeadMutation.isLoading || !guid}
                onClick={() => handleAgree(false)}
              >
                {t("dialogs.no")}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Form>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={validateLeadMutation.isError ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
